import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__ml_asset_reservation } from '@shared/dto/+model/reservation/DTO__ml_asset_reservation';
import { timestamp_ms } from '@shared/utils/utils_time';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateMLAsset } from './state_ml_asset';

export const local_ml_asset_reservations_upsert = (payload: DTO__ml_asset_reservation[]): PayloadAction<DTO__ml_asset_reservation[]> => ({
  type: ENUM__redux_action.ML_ASSET_RESERVATIONS_UPSERT,
  payload,
});

export function init_local_ml_asset_reservations_upsert(state: StateMLAsset, action: PayloadAction<DTO__ml_asset_reservation[]>) {
  if (action.payload.length == 0) return;

  let timestamp = timestamp_ms();

  for (let reservation of action.payload) {
    let is_active = timestamp < reservation.expired_at;

    if (is_active) {
      let diffusion_model_reservations_map = state.reservations_current_workspace_active_map.get_value_or_default(reservation.diffusion_model_id, new Map());

      diffusion_model_reservations_map.set(reservation._id, reservation);

      state.reservations_current_workspace_active_map.set(reservation.diffusion_model_id, diffusion_model_reservations_map);
    }

    state.reservations_map_all.set(reservation._id, reservation);
  }

  //need to force re-render
  state.reservations_current_workspace_active_map = new Map(state.reservations_current_workspace_active_map);
  //need to force re-render
  state.reservations_map_all = new Map(state.reservations_map_all);
}
